import React from 'react'
import logo from '../images/logo.png';
import { useTranslation } from 'react-i18next';



const VerificationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex  justify-center items-center h-screen">
      <div className="max-w-xs mx-auto p-4   rounded-lg  text-center  bg-fbfcfc">
        <img src={logo} alt="" className="mb-4 mx-auto" />
        <h1 className="text-2xl font-bold">{t("Verification")}</h1>
        <p className="text-gray-500 text-sm mt-4">
          {t("Enter_the_8-digit_Crypex_security_code_and_your_phone_number_will_be_verified")}
        </p>
        <p className="mt-6 ml-4 text-left text-gray-500 text-xs	">{t("VERIFICATION_CODE")}</p>
        <input
          type="number"
          placeholder="Enter code"
          className="w-full px-2 py-3 mt-2 border  rounded-lg  pl-7 text-xs border-gray-500 	"
        />
        <p className="mt-2 text-gray-500 text-xs">
          {t("Don't_receive_your_code?")}<span className="text-gray-600 font-bold">{t("Resend")}</span> {t("or")}{' '}
          <span className="text-gray-600 font-bold">{t("Send to Email")}</span>
        </p>
        <div>
          <button 
          //type='submit'
          className="flex items-center justify-center focus:outline-none text-white text-sm bg-primaryColor mt-8 rounded-xl md:rounded-xl md:py-3 py-3 w-full"

          
          >{t("Submit")}</button>
        </div>
      </div>
    </div>
  )
}

export default VerificationPage